import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    title: t('srv1_t'),
    description: t('srv1_d')
  }, {
    title: t('srv2_t'),
    description: t('srv2_d')
  }, {
    title: t('srv3_t'),
    description: t('srv3_d')
  }, {
    title: t('srv4_t'),
    description: t('srv4_d')
  }, {
    title: t('srv5_t'),
    description: t('srv5_d')
  }, {
    title: t('srv6_t'),
    description: t('srv6_d')
  }];
  return <section className="w-full py-24 relative overflow-hidden" data-id="element-227">
      {/* Marble Background */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rL7dK7UH3wwQa67MzLqofL/textura-de-marmol-blanco-y-dorado-natural-para-tapiceria-tela-piel-fondo-lujo-interiores-paredes-arte-ceramica-piedra-creativa-268157195.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-228"></div>
      <div className="absolute inset-0 vignette-overlay pointer-events-none" data-id="element-229"></div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center rounded-2xl px-10 py-8" style={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(16px) saturate(180%)',
          WebkitBackdropFilter: 'blur(16px) saturate(180%)',
          border: '1px solid rgba(212, 175, 55, 0.2)'
        }} data-id="element-232">
            <div className="flex items-center gap-4 mb-4" data-id="element-233">
              <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-234"></div>
              <h2 className="font-serif text-2xl md:text-3xl tracking-[0.3em] uppercase text-[#C9956A]" data-id="element-235">
                {t('services_label')}
              </h2>
              <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-236"></div>
            </div>
            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810] mb-6" data-id="element-237">
              {t('services_title')}
            </h3>
            <p className="text-[#7A5C4F] font-light max-w-2xl mx-auto" data-id="element-238">
              {t('services_desc')}
            </p>
          </motion.div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-239">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="relative group p-8 rounded-2xl border border-[#D4AF37]/20 transition-all duration-500 cursor-default hover:shadow-[0_0_30px_rgba(212,175,55,0.15)]" style={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(16px) saturate(180%)',
          WebkitBackdropFilter: 'blur(16px) saturate(180%)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.04)'
        }} data-id="element-240">
              <div className="absolute top-0 left-8 right-8 h-[2px] bg-gradient-to-r from-transparent via-[#D4AF37]/50 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-241"></div>

              <h4 className="font-serif text-2xl text-[#2C1810] mb-4 leading-tight" data-id="element-242">
                {service.title}
              </h4>
              <p className="text-[#5C3D2E] font-light leading-relaxed" data-id="element-243">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}